import { customAxios } from '../../common/customAxios';

interface IPatchInformationByIdParams {
  informationId: string;
  reqBody: {
    views: number;
  };
}

export const patchInformationById = ({ informationId, reqBody }: IPatchInformationByIdParams): Promise<void> => {
  return customAxios.patch(`/informations/${informationId}`, reqBody);
};
